import React, { Fragment, useEffect, useState, useRef } from 'react';
import HeadUser from '../../models/HeadUser';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom'

const FormPartial = (props) => {
  const { headUser, setHeadUser } = props;
  let headUserObj = new HeadUser(headUser);
  const [branches, setBranches] = useState([]);
  const [zones, setZones] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [branchesApi] = getApi('branches');
  const [clustersApi] = getApi('clusters');
  const [zonesApi] = getApi('zones');
  const [headUserTypes, setHeadUserTypes] = useState([]);
  const [headUserTypesApi] = getApi('usersTypes');
  const clustersRef = useRef();
  const circleRef = useRef();
  const zonalRef = useRef();
  const params = useParams();

  useEffect(() => {
    fetchApiData(headUserTypesApi, "users_types", { filters: {  head_users_types: true } }, setHeadUserTypes);
    fetchApiData(zonesApi, "zones", { fields: 'options' }, setZones);
    fetchApiData(branchesApi, "branches", { fields: 'options' }, setBranches);
    fetchApiData(clustersApi, "clusters", { fields: 'options' }, setClusters);
  }, [])

  const fetchApiData = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
      toast.error(error.data.data.message || "Something went wrong while fetching data !");
    }
  }

  const validateValue = (field) => {
    headUserObj.validate(field);
  }

  const changeValue = (field, value) => {
    headUserObj[field] = value;
    setHeadUser(headUserObj.toStateJson());
    validateValue(field);
  }

  const onUserTypeSelect = (userTypeId, event) => {
    if(event.target.checked) {
      let to_add_role = headUserObj.user_roles.filter((role)=> role.users_type_id == event.target.id);
      if(to_add_role[0]?.id != undefined || to_add_role[0]?.id != null) {
        udpate_destroy_key(to_add_role[0]);
      } else {
        headUserObj.user_roles.push({id: null, users_type_id: Number(event.target.id) });
      }
      if(userTypeId == 23) headUserObj['profiles'] = ['sales_profile']
    } else {
      let to_remove_role = headUserObj.user_roles.filter((role)=> role.users_type_id == event.target.id);
      if(to_remove_role[0].id != undefined || to_remove_role[0].id != null) {
        udpate_destroy_key(to_remove_role[0]);
      } else {
        headUserObj.user_roles = headUserObj.user_roles.filter((role)=> role.users_type_id != event.target.id);
      }
      if(userTypeId == 23) headUserObj['profiles'] = []
    }
    setHeadUser(headUserObj.toStateJson());
    validateValue('user_roles');
  };

  const udpate_destroy_key = (role) => {
    let index = -1;
    headUserObj.user_roles.forEach((user_role, i)=> {
      if(role.id == user_role.id) {
        index = i
      }
    })
    if(index != -1) {
      headUserObj.user_roles[index] = { 
        ...headUserObj.user_roles[index], 
        _destroy: Object.keys(headUserObj.user_roles[index]).includes("_destroy") ? !headUserObj.user_roles[index]._destroy : true } 
    }
  }


  const onProfiletypeSelect = (event) => {
    const { value, checked } = event.target;
    if(checked){
      headUserObj.profiles.push(value);
    } else{
      headUserObj.profiles = headUserObj.profiles.filter(profile_type => profile_type !== value)
    }
    validateValue('profiles');
    setHeadUser(headUserObj.toStateJson());
  };

  const onBranchSelect = (selectedList, selectedItem) => {
    headUserObj['circles'].push(selectedItem)
    validateValue("circles");
    setHeadUser(headUserObj.toStateJson());
  }

  const onBranchRemove = (removedList, removedItem) => {
    headUserObj.circles = headUserObj.circles.filter(circle => circle.id != removedItem.id)
    setHeadUser(headUserObj.toStateJson());
  }

  const onClusterSelect = (selectedList, selectedItem) => {
    headUserObj['clusters'].push(selectedItem);
    validateValue("clusters");
    setHeadUser(headUserObj.toStateJson());
  }

  const onClusterRemove = (removedList, removedItem) => {
    headUserObj.clusters = headUserObj.clusters.filter(cluster => cluster.id != removedItem.id)
    setHeadUser(headUserObj.toStateJson());
  }

  const onZoneSelect = (selectedList, selectedItem) => {
    headUserObj['zones'].push(selectedItem)
    validateValue("zones");
    setHeadUser(headUserObj.toStateJson());
  }

  const onCircleOptionSelectForCluster = (selectedList, selectedItem) => {
    fetchApiData(clustersApi, "clusters", { filters: {branch_ids: selectedList.map(item=> item.id)}}, setClusters);
  }

  const onUserBranchSelect = (selectedList, selectedItem) => {
    headUserObj['branch_id'] = selectedItem.id
    headUserObj['branch_name'] = selectedItem.name
    validateValue("branch_id");
    setHeadUser(headUserObj.toStateJson());
  }

  function intersection (a, b) {
    if(a == undefined || b == undefined) return

    const setA = new Set(a);
    return b.filter(value => setA.has(value.id));
  }

  const zoneSelectoptions = () => {
    if(headUserObj.user_roles.filter(role=>role.users_type_id == 18).length == 0) return;

    return <div className="col-md-2 my-2">
        <label htmlFor="zone_ids" className='form-label'>Select Zone</label>
          <Multiselect
            id="zone_ids"
            options={zones}
            selectedValues={headUserObj.zones}
            onSelect={onZoneSelect}
            placeholder='Select zone from options'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
            ref={zonalRef}
            disablePreSelectedValues={true}
          />
        <div id="head_user_type_help" className="form-text text-danger mt-0">
          {headUserObj.errors.zones}
        </div>
      </div>
  }
  const circleSelectOptions = () => {
    if(headUserObj.user_roles.filter(role=>role.users_type_id == 11).length == 0) return;

    return <div className="col-md-2 my-2">
        <label htmlFor="branch_ids" className='form-label'>Select Circle</label>
          <Multiselect
           id="branch_ids"
           options={branches}
           selectedValues={intersection(branches.map(branch=>branch.id), headUserObj.circles)}
           onSelect={onBranchSelect}
           onRemove={onBranchRemove}
           placeholder='Select from options'
           displayValue={'name'}
           showArrow={true}
           customArrow={true}
           avoidHighlightFirstOption={true}
           disablePreSelectedValues={true}
         />
        <div id="head_user_type_help" className="form-text text-danger mt-0">
          {headUserObj.errors.circles}
        </div>
      </div>
  }
  const clusterSelectoptions = () => {
    if(headUserObj.user_roles.filter(role=>role.users_type_id == 10).length == 0) return;

    return <div className="col-md-2 my-2">
        <label htmlFor="branch_ids" className='form-label'>Select Clusters</label>
          <Multiselect
           id="branch_ids"
           options={clusters}
           selectedValues={headUserObj.clusters}
           onSelect={onClusterSelect}
           onRemove={onClusterRemove}
           placeholder='Select from options'
           displayValue={'name'}
           showArrow={true}
           customArrow={true}
           avoidHighlightFirstOption={true}
           disablePreSelectedValues={true}
         />
        <div id="head_user_type_help" className="form-text text-danger mt-0">
          {headUserObj.errors.clusters}
        </div>
      </div>
  }
  const profilesSelectOptions = () => {
    if(headUserObj.user_roles.filter(role=>role.users_type_id == 1 && role._destroy != true).length == 0) return;

    return <div className="col-md-2 my-2">
      <label htmlFor="profiles" className="form-label mb-1">Select Profile Type</label>
          <div className="form-check mt-2">
            <input
              id="operations_profile"
              className="form-check-input"
              type="checkbox"
              onChange={onProfiletypeSelect}
              value='operations_profile'
              checked={headUserObj.profiles.includes('operations_profile')}
            />
            <label className="form-check-label" htmlFor="operations_profile">
              Operational Profile
            </label>
          </div>
          <div className="form-check">
            <input
              id="sales_profile"
              className="form-check-input"
              type="checkbox"
              onChange={onProfiletypeSelect}
              value='sales_profile'
              checked={headUserObj.profiles.includes('sales_profile')}
            />
            <label className="form-check-label" htmlFor="sales_profile">
              Sales Profile
            </label>
          </div>
          <div id="profiles_help" className="form-text text-danger mt-0">
            {headUserObj.errors.profiles}
          </div>
        </div>
  }

  const userBranchSelection = () => {
    console.log(headUserObj.user_roles)
    if(headUserObj.user_roles.filter(role=>role.users_type_id == 1 && role._destroy != true).length == 0 && headUserObj.user_roles.filter(role=>role.users_type_id == 23 && role._destroy != true).length == 0) return;
    
    return <div className="col-md-2 my-2">
        <label htmlFor="branch_ids" className='form-label'>Select Circle</label>
          <Multiselect
           id="branch_ids"
           options={branches}
           selectedValues={[{id: headUserObj.branch_id, name: headUserObj.branch_name}]}
           onSelect={onUserBranchSelect}
           placeholder='Select from options'
           displayValue={'name'}
           showArrow={true}
           customArrow={true}
           singleSelect={true}
           // disable={headUserObj.id != null}
           avoidHighlightFirstOption={true}
           disablePreSelectedValues={true}
         />
        <div id="head_user_type_help" className="form-text text-danger mt-0">
          {headUserObj.errors.branch_id}
        </div>
      </div>
  }

  return <Fragment>
  <div className="row mt-4">
      <div className="col-md-6 my-2">
        <label htmlFor="name" className="form-label mb-1">Name</label>
        <input
          id="name"
          value={headUserObj.name}
          onChange={(e) => changeValue('name', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Name'
          aria-describedby="name_help"
        />
        <div id="name_help" className="form-text text-danger mt-0">
          {headUserObj.errors.name}
        </div>
      </div>
      <div className="col-md-6 my-2">
        <label htmlFor="email" className="form-label mb-1">Email</label>
        <input
          id="email"
          value={headUserObj.email}
          onChange={(e) => changeValue('email', e.target.value)}
          type="email"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Email'
          aria-describedby="email_help"
        />
        <div id="email_help" className="form-text text-danger mt-0">
          {headUserObj.errors.email}
        </div>
      </div>
      <div className="col-md-6 my-2">
        <label htmlFor="mobile_number" className="form-label mb-1">Mobile Number</label>
        <input
          id="mobile_number"
          value={headUserObj.mobile_number}
          onChange={(e) => changeValue('mobile_number', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Mobile Number'
          aria-describedby="mobile_help"
          maxLength={10}
        />
        <div id="mobile_help" className="form-text text-danger mt-0">
          {headUserObj.errors.mobile_number}
        </div>
      </div>
      <div className="col-md-6 my-2">
        <label htmlFor="employee_id" className="form-label mb-1">Employee Id</label>
        <input
          id="employee_id"
          value={headUserObj.employee_id}
          onChange={(e) => changeValue('employee_id', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          placeholder='Enter Employee ID'
          aria-describedby="employee_id_help"
        />
        <div id="employee_id_help" className="form-text text-danger mt-0">
          {headUserObj.errors.employee_id}
        </div>
      </div>
    </div>

    <div className='row mt-4'>
      <div className="col-md-3 my-2">
        <label htmlFor="head_user_type" className="form-label mb-1">Select Head User Type</label>
        {headUserTypes.map((userType) =>
          {return <div className="form-check mt-2" key={userType.id}>
          <input
            id={userType.id}
            checked={
              headUserObj.user_roles.filter(role=>role.users_type_id == userType.id && (role._destroy == false || role._destroy == undefined)).length != 0 
            }
            className="form-check-input"
            type="checkbox"
            onChange={(event) => onUserTypeSelect(userType.id, event)}
            name="head_user_type"
          />
          <label className="form-check-label" htmlFor={userType.role_name}>{(userType.role_name).split('_').join(' ')}</label>
        </div>}
        )}
        <div id="head_user_type_help" className="form-text text-danger mt-0">
          {headUserObj.errors.user_roles}
        </div>
      </div>
      {profilesSelectOptions()}
      {userBranchSelection()}
    </div>
  </Fragment>
}

export default FormPartial;









{/*<Fragment>
    
    <div className='row mt-4'>
      <div className="col-md-3 my-2">
        <label htmlFor="head_user_type" className="form-label mb-1">Select Head User Type</label>
        {headUserTypes.length !== 0 && headUserTypes.map((userType) =>
          {return <div className="form-check mt-2" key={userType.id}>
          <input
            id={userType.role_name}
            checked={headUserObj?.head_user_type?.includes(userType.role_name)}
            className="form-check-input"
            type="radio"
            disabled={params.id != undefined}
            onChange={(event) => onHeadUspeSelect(userType.id, event)}
            name="head_user_type"
          />
          <label className="form-check-label" htmlFor={userType.role_name}>
           {(userType.role_name).split('_').join(' ')}
          </label>
        </div>}
        )}
        <div id="head_user_type_help" className="form-text text-danger mt-0">
          {headUserObj.errors.head_user_type}
        </div>
        <div className="text-danger">{params.id != undefined && "Cannot update users type"}</div>
      </div>

      {(headUserObj.head_user_type === 'zonal_head') &&
        <React.Fragment>
          <div className="col-md-3 my-2">
            <label htmlFor="zone_ids" className='form-label'>Select Zone</label>
            <Multiselect
              id="zone_ids"
              options={zones}
              selectedValues={headUserObj.zone_ids ? zones.filter(zone => headUserObj.zone_ids.includes(zone.id)) : []}
              onSelect={onZoneSelect}
              placeholder='Select zone from options'
              displayValue={'name'}
              showArrow={true}
              customArrow={true}
              singleSelect={true}
              avoidHighlightFirstOption={true}
              ref={branchForClustersRef}
              disable={headUserObj.zones.length !== 0}
            />
          </div>
        </React.Fragment>
      }
      {(headUserObj.head_user_type === 'area_head') &&
        <React.Fragment>
            <div className="col-md-3 my-2">
              <label htmlFor="profiles" className="form-label mb-1">Select Profile Type</label>
              <div className="form-check mt-2">
                <input
                  id="operations_profile"
                  className="form-check-input"
                  type="checkbox"
                  onChange={onProfiletypeSelect}
                  value='operations_profile'
                  disabled={headUserObj.head_user_type === 'FSO'}
                  checked={headUserObj.head_user_type === 'FSO' ? false : headUserObj.profiles.includes('operations_profile')}
                />
                <label className="form-check-label" htmlFor="operations_profile">
                  Operational Profile
                </label>
              </div>
              <div className="form-check">
                <input
                  id="sales_profile"
                  className="form-check-input"
                  type="checkbox"
                  onChange={onProfiletypeSelect}
                  value='sales_profile'
                  disabled={headUserObj.head_user_type === 'FSO'}
                  checked={headUserObj.head_user_type === 'FSO' ? true : headUserObj.profiles.includes('sales_profile')}
                />
                <label className="form-check-label" htmlFor="sales_profile">
                  Sales Profile
                </label>
              </div>
              <div id="profiles_help" className="form-text text-danger mt-0">
                {headUserObj.errors.profiles}
              </div>
            </div>
        </React.Fragment>
      }
      {(headUserObj.head_user_type === 'cluster_head') &&
        <React.Fragment>
          <div className="col-md-3 my-2">
            <label htmlFor="branch_for_cluster" className='form-label'>Select Circle</label>
            <Multiselect
              id="branch_for_cluster"
              options={branches}
              selectedValues={headUserObj.branch_for_cluster ? branches.filter(branch => headUserObj.branch_for_cluster.includes(branch.name)) : []}
              onSelect={onCircleOptionSelectForCluster}
              placeholder='Select from options'
              displayValue={'name'}
              showArrow={true}
              customArrow={true}
              avoidHighlightFirstOption={true}
              ref={branchForClustersRef}
              disable={headUserObj.clusters.length !== 0}
            />
          </div>
          <div className="col-md-3 my-2">
            <label htmlFor="cluster_ids" className='form-label'>Select Cluster</label>
            <Multiselect
              id="cluster_ids"
              options={clusters}
              selectedValues={headUserObj.cluster_ids ? clusters.filter(cluster => headUserObj.cluster_ids.includes(cluster.id)) : []}
              onSelect={onClusterSelect}
              placeholder='Select from options'
              displayValue={'name'}
              showArrow={true}
              customArrow={true}
              avoidHighlightFirstOption={true}
              ref={clustersRef}
              disable={headUserObj.clusters.length !== 0}
            />
            <div id="employee_id_help" className="form-text text-danger mt-0">
              {headUserObj.errors.cluster_ids}
            </div>
          </div>
        </React.Fragment>
      }
      {(headUserObj.head_user_type === 'circle_head') &&
        <React.Fragment>
          <div className="col-md-3 my-2">
            <label htmlFor="branch_ids" className='form-label'>Select Circle</label>
            <Multiselect
             id="branch_ids"
             options={branches}
             selectedValues={branches.filter(branch => headUserObj.branch_ids.includes(branch.id)) || []}
             onSelect={onBranchSelect}
             placeholder='Select from options'
             displayValue={'name'}
             showArrow={true}
             customArrow={true}
             singleSelect={true}
             avoidHighlightFirstOption={true}
             disable={headUserObj.circles.length !== 0}
           />
           <div id="employee_id_help" className="form-text text-danger mt-0">
             {headUserObj.errors.branch_ids}
           </div>
          </div>
        </React.Fragment>
      }
    </div>
*/}
